// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IOrganizationClaimNoteDto
 */
export interface IOrganizationClaimNoteDto {
    /**
     * 
     * @type {number}
     * @memberof IOrganizationClaimNoteDto
     */
    organization_id?: number;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationClaimNoteDto
     */
    organization_type?: IOrganizationClaimNoteDtoOrganizationTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationClaimNoteDto
     */
    organization_name?: string;
    /**
     * 
     * @type {string}
     * @memberof IOrganizationClaimNoteDto
     */
    note?: string;
}

/**
* @export
* @enum {string}
*/
export enum IOrganizationClaimNoteDtoOrganizationTypeEnum {
    SYSTEM = 'SYSTEM',
    PARTNER = 'PARTNER',
    DISTRIBUTOR = 'DISTRIBUTOR',
    COMPANY = 'COMPANY',
    SUBSIDIARY = 'SUBSIDIARY',
    SUBGROUP = 'SUBGROUP'
}


/**
 * Check if a given object implements the IOrganizationClaimNoteDto interface.
 */
export function instanceOfIOrganizationClaimNoteDto(value: object): value is IOrganizationClaimNoteDto {
    return true;
}

export function IOrganizationClaimNoteDtoFromJSON(json: any): IOrganizationClaimNoteDto {
    return IOrganizationClaimNoteDtoFromJSONTyped(json, false);
}

export function IOrganizationClaimNoteDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IOrganizationClaimNoteDto {
    if (json == null) {
        return json;
    }
    return {
        
        'organization_id': json['organization_id'] == null ? undefined : json['organization_id'],
        'organization_type': json['organization_type'] == null ? undefined : json['organization_type'],
        'organization_name': json['organization_name'] == null ? undefined : json['organization_name'],
        'note': json['note'] == null ? undefined : json['note'],
    };
}

export function IOrganizationClaimNoteDtoToJSON(json: any): IOrganizationClaimNoteDto {
    return IOrganizationClaimNoteDtoToJSONTyped(json, false);
}

export function IOrganizationClaimNoteDtoToJSONTyped(value?: IOrganizationClaimNoteDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'organization_id': value['organization_id'],
        'organization_type': value['organization_type'],
        'organization_name': value['organization_name'],
        'note': value['note'],
    };
}

